import { Filter } from '@empathy/search-types';
import { deepMerge } from '@empathybroker/deep-merge';
import { SearchState } from '../../../models';
import { SEARCH_MUTATIONS_KEYS } from '../search.const';
import { SearchMutation } from '../search.interfaces';

interface UpdateFilterValueMutationPayload {
  filter: Filter;
  value: any;
}

export class UpdateFilterValueMutation implements SearchMutation {
  mutations = {
    [SEARCH_MUTATIONS_KEYS.updateFilterValue]: (searchState: SearchState, { filter, value }: UpdateFilterValueMutationPayload) => {
      deepMerge(filter.value, value);
    }
  };
}
